import React from 'react';
import './promoItem.css';
import { useDispatch } from "react-redux";
import { photoFileAction, promoFormAction } from "../../redux/rootReducer";
import { site } from "../../config";
import image from '../../assets/i/image.svg';
import { removePromoSagaAction } from "../../redux/sagaActions";

const PromoItem = ({ data }) => {
    const dispatch = useDispatch();

    return (
        <div className="promo">
            <div className="controls">
                <i className="control control--edit"
                    onClick={ () => {
                        dispatch(promoFormAction({
                            open: true,
                            id: data.id,
                            image: data.image,
                            name: data.name,
                            description: data.description,
                            code: data.code,
                            discount: data.discount,
                            active: data.active,
                            establishments: data.establishment,
                            news: data.news,
                            date: data.date,
                            expire: data.expire,
                            goods: data.goods,
                            link: data.link
                        }));
                        dispatch(photoFileAction(null));
                    } }
                />
                <i className="control control--move" />
                <i className="control control--remove"
                    onClick={ () => {

                        if (window.confirm('Вы действительно хотите удалить эту акцию?')) {
                            dispatch(removePromoSagaAction({
                                promo_id: data.id
                            }));
                        }
                    } }
                />
            </div>
            <div className="promo__image" style={{
                backgroundImage: `url(${ data.image ? site + data.image : image })`,
                backgroundSize: data.image ? 'cover' : false,
                opacity: data.image ? 1 : .48
            }}/>
            <div
                className={ `promo__status ${ data.active === '1' ? 'promo__status--active' : 'promo__status--inactive' }` }
            >{ data.active === '1' ? 'Активна' : 'Неактивна' }</div>
            {
                data.code ? <div className="promo__code">{ data.code }</div> : false
            }
            <div className="promo__name">{ data.name }</div>
            <div className="promo__description">{ data.description }</div>
        </div>
    );
};

export default PromoItem;